export const ROOT_ROUTE = '/';
export const DOWNLOAD_ROUTE = '/download';
export const SIGN_IN_ROUTE = '/signin';
export const SSO_ROUTE = '/sso';
export const SIGN_IN_ROUTE_WITH_GOTO = '/signin/:referrer?';
export const SIGN_OUT_ROUTE = '/signout';
export const HOME_ROUTE = '/home';

export const MODULE_ROUTE = '/:module?/:view?/:actionName?/:documentTypeId?/:documentId?/:wsId?';
